export const HelloWorld = {
  information:
    'For a guide and recipes on how to configure / customize this project,<br />check out the {0}.',
  documentation: 'vue-cli documentation',
  installed_CLI_plugins: 'Installed CLI Plugins',
};
